import { render, staticRenderFns } from "./CreateContainer.vue?vue&type=template&id=480c67ce&scoped=true"
import script from "./CreateContainer.vue?vue&type=script&lang=js"
export * from "./CreateContainer.vue?vue&type=script&lang=js"
import style0 from "./CreateContainer.vue?vue&type=style&index=0&id=480c67ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c67ce",
  null
  
)

export default component.exports